import { FC } from 'react';
import { ChildrenPropType } from 'src/utils/types';

type Props = {
  children: ChildrenPropType;

  id?: string;
};

export const MaterialLabel: FC<Props> = ({ children, id }) => (
  <label htmlFor={id} className="field-material-label">
    {children}
  </label>
);
